import { h } from 'preact'
import { useState } from 'preact/hooks'
import FormInput from '../elements/FormInput'
import initializeForm from '../utilities/initializeForm'

import sharedStyles from '../sharedStyles.module.scss'

import { formFields, formSchema } from './config'
import ChartContainer from '../../charts/ChartContainer/ChartContainer'
import formatNumber from '../../../utilities/formatNumber'

function calculateResults(formData) {
  const {
    rateOfReturn,
    age,
    monthlyContribution,
    startingInvestment,
    yearsInSchool,
    annualCost,
  } = formData

  const monthlyRate = Number(rateOfReturn) / 12 / 100
  const monthsLeft = (18 - Number(age)) * 12

  const grant =
    Number(monthlyContribution) * 12 > 2500
      ? 500
      : 0.2 * Number(monthlyContribution) * 12

  const totalResp =
    Number(startingInvestment) * Math.pow(1 + monthlyRate, monthsLeft) +
    (monthlyContribution + grant / 12) *
      ((Math.pow(1 + monthlyRate, monthsLeft) - 1) / monthlyRate)

  const totalCost = Number(yearsInSchool) * annualCost

  return { totalCost, grant, totalResp, totalCost, monthlyContribution }
}

export default function RespForm({ formName }) {
  const [view, setView] = useState('form')
  const [results, setResults] = useState(null)
  const { formValues, formErrors, handleInputChange, validateForm, resetForm } =
    initializeForm({
      initialValues: {
        age: '1',
        yearsInSchool: '1',
        annualCost: '',
        startingInvestment: '',
        monthlyContribution: '',
        rateOfReturn: '3',
      },
      formSchema,
    })

  function submit() {
    validateForm().then(validFormData => {
      setView('results')
      setResults(calculateResults(validFormData))
    })
  }

  if (view === 'results') {
    return (
      <ChartContainer
        edit={() => {
          setView('form')
          setResults(null)
        }}
        reset={() => {
          setView('form')
          setResults(null)
          resetForm()
        }}
      >
        <p>
          With a monthly investment of $
          {formatNumber(results.monthlyContribution)}, your RESP savings will
          be:
        </p>
        <p>
          Canada Education Savings Grant per year: $
          {formatNumber(results.grant)}
        </p>
        <p>Total RESP Investment: ${formatNumber(results.totalResp)}</p>
        <p>Total Education Cost: ${formatNumber(results.totalCost)}</p>
      </ChartContainer>
    )
  }

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        submit()
      }}
      className={sharedStyles.Form}
    >
      {Object.entries(formFields).map(([key, input]) => {
        const id = `${formName}-${key}`
        return (
          <FormInput
            key={id}
            id={id}
            identifier={key}
            input={input}
            error={formErrors?.[key]}
            value={formValues?.[key]}
            handleInputChange={handleInputChange}
          />
        )
      })}
      <div className={sharedStyles.SubmitContainer}>
        <button type="submit" className="button dark">
          Calculate
        </button>
      </div>
    </form>
  )
}
